import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Button } from '@pancakeswap/uikit'

export const CustomButton = styled(Button)`
  background: #FFF;
  color: #0C0C0C;

  &:hover {
    text-decoration: none;
  }
`

export default CustomButton
